<template>
  <div class="d-flex flex-column align-items-center col-12 vue-container">
    <div v-if="windowWidth >= 576">
      <DesktopHome/>
    </div>
    <div v-if="windowWidth < 576">
      <MobileHome/>
    </div>
  </div>
</template>

<script>
import DesktopHome from "@/views/desktop/DesktopHome";
import MobileHome from "@/views/mobile/MobileHome";
import {ref} from 'vue'

const windowWidth = ref(window.innerWidth)
const handleResize = () => {
  windowWidth.value = window.innerWidth
}

export default {
  name: 'LoginPage',
  data() {
    return {
      windowWidth: windowWidth
    }
  },
  components: {DesktopHome, MobileHome},
  mounted() {
    window.addEventListener('resize', handleResize)
  },
  unmounted() {
    window.removeEventListener('resize', handleResize)
  },
}
</script>
